import {
  FormControlLabel,
  Grid,
  Radio,
  Switch,
  RadioGroup,
  Button,
  IconButton,
  InputAdornment,
  Box,
  Typography,
  Checkbox,
} from "@mui/material";
import EventIcon from '@mui/icons-material/Event';

import RemoveCircleIcon from "@mui/icons-material/RemoveCircleOutline";
import { Field, FieldArray, FieldArrayRenderProps } from "formik";
import DatePicker from "react-multi-date-picker";
import AddIcon from "@mui/icons-material/Add";

import { useRef } from "react";
import {
  ClientInvoicePeakSurchargeUIRequest,
  EditClientInvoiceRouteRateUIRequest,
  PeakSurchargeDateRangeValue,
} from "../ClientInvoiceInterfaces";
import FormikTextField from "../../../../components/common/formikFields/FormikTextField";
import {
  ClientInvoiceEditDetailResponse,
  RouteResponse,
} from "../../../../app/models/responseModels/ClientInvoiceResponses";
import { RatecardResponse } from "../../ratecard/dtos/RateCardResponse";
import { formatDate } from "../../../../components/common/utils/DateUtils";

interface Props {
  values: EditClientInvoiceRouteRateUIRequest;
  handleChange: any;
  handleBlur: any;
  setFieldValue: any;
  invoiceStartDate: Date;
  invoiceEndDate: Date;
  route: RouteResponse | null;
  originalRatecardData: RatecardResponse | undefined;
  editData: ClientInvoiceEditDetailResponse | null;
}

const CiPeakSurcharge = (props: Props) => {
  const { values, handleChange, handleBlur, setFieldValue } = props;
  console.log("VALUES IN PEAK SURCHARGE", values);

  // Log peakSurcharge date ranges as JavaScript Date objects

  
    const ArrayHelperRef = useRef<FieldArrayRenderProps>();

  const disableFieldDateRanges = () => {
    if (
      props.values.master_date_range === undefined ||
      (props.values.master_date_range &&
        props.values.master_date_range.length < 2)
    )
      return false;
    return true;
  };

  const isDisabledDate = (
    date: Date,
    peakSurcharges: ClientInvoicePeakSurchargeUIRequest[]
  ) => {
    let isDisabled = false;
    peakSurcharges &&
      peakSurcharges.length > 0 &&
      peakSurcharges.every((surcharge) => {
        // we want to set isDisabled to true and break if the date is in the min-max date range
        // So, we need to use every() because there is no way to break out of a forEach() loop
        // when using every() return true if you want to break else return false
        if (
          surcharge.peak_surcharge_date_range &&
          surcharge.peak_surcharge_date_range.length >= 2 &&
          surcharge.peak_surcharge_date_range[0] &&
          surcharge.peak_surcharge_date_range[1]
        ) {
          const minDate = surcharge.peak_surcharge_date_range[0].toDate();
          const maxDate = surcharge.peak_surcharge_date_range[1].toDate();

          date.setHours(0, 0, 0, 0);
          minDate.setHours(0, 0, 0, 0);
          maxDate.setHours(0, 0, 0, 0);

          if (date >= minDate && date <= maxDate) {
            isDisabled = true;
            return false;
          }
          return true;
        }
      });
    return isDisabled;
  };

  const resetFieldAndDateRange = (
    fieldName: string,
    dateRangeFieldName: string
  ) => {
    // props.setFieldValue(fieldName, props.resetValue);
    setFieldValue(`show_discount`, false);
    setFieldValue(dateRangeFieldName, []);


  };

  return (
    <>
      <Grid container alignItems={"center"} sx={{ mt: 2 }}>
      <Grid item>
  <FormControlLabel
    id="show_peak_surcharge"
    name="show_peak_surcharge"
    label="Peak Surcharge"
    labelPlacement="start"
    sx={{ mr: 2 }}
    control={
      <Field name="show_peak_surcharge">
        {({ field, form }: any) => (
          <Checkbox
            {...field}
            checked={field.value}
            onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
              form.setFieldValue(field.name, checked);
            }}
          />
        )}
      </Field>
    }
  />
</Grid>

        <Grid item display={values.show_peak_surcharge ? "" : "none"}>
          <FormikTextField
            id="peak_surcharge_custom_value"
            name="peak_surcharge_custom_value"
            variant="outlined"
            size="small"
            type="number"
            label="Add Custom Value"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
<Grid
  container
  item
  alignItems={"center"}
  columnSpacing={2}
  display={values.show_peak_surcharge ? "" : "none"}
>
  <FieldArray
    name="peakSurcharge"
    render={(arrayHelpers) => {
      ArrayHelperRef.current = arrayHelpers;

      return values.peakSurcharge.map((peakSurcharge, index) => (
        <Grid 
          container 
          item 
          key={index} 
          xs={12}
          spacing={2} 
          alignItems="center"
        >
          <Grid item xs="auto">
            <RadioGroup
              row
              id={`peakSurcharge.${index}.peakSurchargeType`}
              name={`peakSurcharge.${index}.peakSurchargeType`}
              value={peakSurcharge.peakSurchargeType}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <FormControlLabel
                control={<Radio />}
                value="percentage"
                disabled={values.peak_surcharge_custom_value ? true : false}
                label={
                  <FormikTextField
                    id={`peakSurcharge.${index}.peak_surcharge_value_percentage`}
                    name={`peakSurcharge.${index}.peak_surcharge_value_percentage`}
                    variant="outlined"
                    size="small"
                    label=""
                    disabled={values.peak_surcharge_custom_value ? true : false}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          %
                        </InputAdornment>
                      ),
                    }}
                  />
                }
              />
              <FormControlLabel
                control={<Radio />}
                value="value"
                disabled={values.peak_surcharge_custom_value ? true : false }
                label={
                  <FormikTextField
                    variant="outlined"
                    id={`peakSurcharge.${index}.peak_surcharge_value_dollar`}
                    name={`peakSurcharge.${index}.peak_surcharge_value_dollar`}
                    size="small"
                    label=""
                    disabled={values.peak_surcharge_custom_value}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      ),
                    }}
                  />
                }
              />
            </RadioGroup>
          </Grid>

          <Grid item xs="auto">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton
                sx={{
                  color: 'gray',
                  fontSize: '1.5rem',
                  padding: '0.5rem',
                }}
              >
              <EventIcon />
              </IconButton>
                <DatePicker
                format="MM/DD/YYYY"
                className="green"
                dateSeparator=" ~ "
                range
                rangeHover
                placeholder="Date Range"
                style={{ height: "36px", marginTop: "8px" }}
                minDate={props.invoiceStartDate}
                maxDate={(() => {
                  const adjustedEndDate = new Date(props.invoiceEndDate);
                  adjustedEndDate.setHours(23, 59, 59, 999);
                  return adjustedEndDate;
                })()}
                disabled={disableFieldDateRanges()}
                value={peakSurcharge.peak_surcharge_date_range?.length ? peakSurcharge.peak_surcharge_date_range : undefined}
                onChange={(value) => {
                  setFieldValue(`peakSurcharge.${index}.peak_surcharge_date_range`, value);
                }}
                
                mapDays={({ date }) => {
                  let localProps: any = {};
                  if (isDisabledDate(date.toDate(), values.peakSurcharge)) {
                    localProps.disabled = true;
                    localProps.style = { color: "gray", pointerEvents: "none" };
                  }
                  return localProps;
                }}
              />
            </Box>
          </Grid>

          {/* {
            props.route === null ? (
              <IconButton
              color="success"
              disabled={
                disableFieldDateRanges() ||
                (values.peak_surcharge_date_range &&
                  values.peak_surcharge_date_range.length < 2)
              }
              onClick={() => {
                if (
                  // props.field !== undefined &&
                  values.peak_surcharge_date_range.length === 2
                ) {
                  let dateRangeValues = values.peak_surcharge_date_range_values;
                  let peakSurchargeDateRangeValue: PeakSurchargeDateRangeValue = {
                    startDate: values.peak_surcharge_date_range[0].toDate(),
                    endDate: values.peak_surcharge_date_range[1].toDate(),
                  };

                  if (values.peak_surcharge_custom_value)
                    peakSurchargeDateRangeValue.peakSurchargeCustomValue =
                      values.discount_custom_value;
             

                  dateRangeValues.push(peakSurchargeDateRangeValue);
                  setFieldValue(`discount_date_range_values`, dateRangeValues);

                  resetFieldAndDateRange(
                    `props.fieldName`,
                    `peak_surcharge_date_range`
                  );
                }
              }}
            >
              <AddIcon />
            </IconButton>
            ) : null 
          } */}

          <Grid item xs="auto">
            <IconButton
              color="error"
              disabled={values.peak_surcharge_custom_value ? true : false}
              onClick={() => {
                arrayHelpers.remove(index);
              }}
            >
              <RemoveCircleIcon />
            </IconButton>
          </Grid>
        </Grid>
      ));
    }}
  />
  <Grid item xs={12} mt={2}>
    <Button
      variant="contained"
      disabled={values.peak_surcharge_custom_value ? true : false}
      onClick={() => {
        ArrayHelperRef.current?.push({});
      }}
    >
      Add
    </Button>
  </Grid>
</Grid>
      {/* Original Peak Surcharge */}
      {props.route !== null &&
      props.editData?.ratecardPeakSurcharges &&
      props.editData.ratecardPeakSurcharges.length > 0 ? (
        <Grid
          id="original-peak-surcharge"
          container
          item
          sm={12}
          md={12}
          lg={12}
        >
          <Box display="block" width="100%">
            <Typography variant="overline" color={"rgb(0, 0, 0, 0.6);"}>
              <>
                {props.originalRatecardData?.ratecardPeakSurcharges.map(
                  (peak, index) => {
                    return `Original: Date Range: ${formatDate(
                      new Date(peak.peakSurchargeMinDate)
                    )} to ${formatDate(
                      new Date(peak.peakSurchargeMaxDate)
                    )}, Value: ${
                      peak.peakSurchargeType === "value" ? "$" : ""
                    }${peak.peakSurchargeValue}${
                      peak.peakSurchargeType === "percentage" ? "%" : ""
                    }`;
                  }
                )}
              </>
            </Typography>
          </Box>
        </Grid>
      ) : null}
    </>
  );
};

export default CiPeakSurcharge;
